import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchLimeResult = async (
  authToken: string,
  cfd_id: string
) => {
  try {
    const { response, data } = await fetchFfdJson<{ body?: { result?: any }; text?: string }>(
      `/trials/lime_result?trial_id=${cfd_id}`,
      authToken
    );
    if (response.ok) {
      return data.body?.result ?? null;
    } else {
      if (data.text) alert(data.text);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return;
  }
};
